import { IEmptyState } from "app/interfaces/empty-state/empty-state.interface";
import ImagePath from "app/utilities/imagePath";

export const portofolioEmptyState: IEmptyState = {
	image: ImagePath.noData,
	placeholder: "Oops, saat ini belum ada portofolio yang tersedia",
	caption: "Portofolio Anda akan terdaftar di sini"
};

export const portofolioFilterEmptyState: IEmptyState = {
	image: ImagePath.noDataFilter,
	placeholder: "Oops, belum ada portofolio yang sesuai filter",
	caption: "Coba reset atau ubah filter kamu, ya"
};

export const agreementAction = [
	{
		id: 1,
		label: 'Lihat Perjanjian Pendanaan'
	},
	{
		id: 2,
		label: 'Lihat Perjanjian Penerima Dana'
	},
	{
		id: 3,
		label: 'Unduh Factsheet'
	},
];

export const AGREEMENT_ENUM = {
	showAgreementFunding: 1,
	showAgreementBorrower: 2,
	downloadFactsheet: 3,
};
